import Big from 'big.js'

import type { CartItemPriceSnapshot } from 'models/purchaseFlowRevamp'

import type { CartExtraSnapshot } from './slices/cartSlice'

/** What a cart line costs: the product per unit times its quantity, plus its add-ons once. */
export const lineTotalOf = (snapshot: CartItemPriceSnapshot, quantity: number): Big =>
  new Big(snapshot.unitPrice).times(quantity).plus(snapshot.addonsPrice ?? 0)

/** The same line without its saving, or null when the line carries none. */
export const baseLineTotalOf = (snapshot: CartItemPriceSnapshot, quantity: number): Big | null =>
  snapshot.baseUnitPrice
    ? new Big(snapshot.baseUnitPrice).times(quantity).plus(snapshot.baseAddonsPrice ?? snapshot.addonsPrice ?? 0)
    : null

/** What an order-level extra costs: the session's price when it has one, the quoted one otherwise. */
export const extraAmountOf = (extra: CartExtraSnapshot): Big => new Big(extra.sessionPrice?.amount ?? extra.unitPrice)

/** The same extra without its saving, or null when it carries none. */
export const extraBaseAmountOf = (extra: CartExtraSnapshot): Big | null =>
  extra.sessionPrice?.baseAmount ? new Big(extra.sessionPrice.baseAmount) : null
